import script from "./EOldRecommendations.vue?vue&type=script&setup=true&lang=ts"
export * from "./EOldRecommendations.vue?vue&type=script&setup=true&lang=ts"

import "./EOldRecommendations.vue?vue&type=style&index=0&id=f3ce26aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3ce26aa"]])

export default __exports__